<div *ngIf="reportType === 'VeryBriefly-Officer'">
  <div class="container-fluid px-4" id="print-section">

    <table class="table table-bordered table-sm mt-4 w-100"
           style="border-collapse: collapse; border: 1px solid black;">

      <!-- ================= HEADER ================= -->
      <thead class="text-center align-middle">

        <!-- Main Header -->
        <tr style="font-size: 16px; font-weight: bold;">
          <th colspan="3" style="border:1px solid black; text-align:center; padding:6px;font-size: 18px;">
            हिंदुस्तान प्रकाशन संस्था 
          </th>
          <th colspan="3" style="border:1px solid black; text-align:center; padding:6px;font-size: 18px;">
            Book Credit Note Report
          </th>
          <th colspan="3" style="border:1px solid black; text-align:right; padding:6px;font-size: 18px;">
            दिनांक {{ currentDate | date: 'dd-MM-yyyy' }}
          </th>
        </tr>

        <!-- Sub Header -->
        <tr style="font-size: 16px; font-weight: bold;">
          <th colspan="3"
              style="border:1px solid black; padding:6px; text-align:center;font-size: 18px;">
           विवेक पुस्तक प्रकाशन
          </th>
          <th colspan="3"
              style="border:1px solid black; padding:6px; text-align:center;font-size: 18px;">
           All In Details 

          </th>
          <th colspan="3"
              style="border:1px solid black; padding:6px; text-align:right;font-size: 18px;">
            Date : From {{ startDate | date:'dd-MM-yyyy' }}  To {{ endDate | date:'dd-MM-yyyy' }}
          </th>
        </tr>

        <!-- Column Headers -->
        <tr style="background-color:#e6e6e6; font-weight:bold;">
          <th style="border:1px solid black; padding:6px;">Credit note Date</th>
          <th style="border:1px solid black; padding:6px;">Credit note No</th>
          <th style="border:1px solid black; padding:6px; text-align:left;width:30%;">Book Seller Name</th>
            <th style="border:1px solid black; padding:6px; text-align:left;">Representative Name</th>
          <th style="border:1px solid black; padding:6px; text-align:left;">Office Rep. Name</th>
          <!-- <th style="border:1px solid black; padding:6px; text-align:left;">Representative Name</th> -->
          <th style="border:1px solid black; padding:6px;">Invoice No</th>
          <th style="border:1px solid black; padding:6px;">Invoice Date</th>
          <th style="border:1px solid black; padding:6px; text-align:right;">Invoice Amount</th>
          <th style="border:1px solid black; padding:6px; text-align:right;">Credit note Amount</th>
        </tr>

      </thead>

      <!-- ================= BODY ================= -->
      <tbody>
        <tr *ngFor="let data of filterData">
          <td style="border:1px solid black; padding:6px;">{{ data.crdtnote_date }}</td>
          <td style="border:1px solid black; padding:6px;">{{ data.crdtnote_no }}</td>
          <td style="border:1px solid black; padding:6px; text-align:left;width:30%;">{{ data.book_seller_name }}</td>
            <td style="border:1px solid black; padding:6px; text-align:left;">{{ data.rep_name }}</td>
          <!-- <td style="border:1px solid black; padding:6px;">{{ data.bill_no }}</td> -->
          <td style="border:1px solid black; padding:6px; text-align:left;">{{ data.office_rep_name }}</td>
          <!-- <td style="border:1px solid black; padding:6px; text-align:left;">{{ data.rep_name }}</td> -->
          <td style="border:1px solid black; padding:6px;">{{ data.bill_no }}</td>
          <td style="border:1px solid black; padding:6px;">{{ data.billdate }}</td>
          <td style="border:1px solid black; padding:6px; text-align:right;">{{ data.bill_amount }}</td>
          <td style="border:1px solid black; padding:6px; text-align:right;">{{ data.crdtnote_total }}</td>
        </tr>
      </tbody>

      <!-- ================= FOOTER ================= -->
      <tfoot>
        <tr style="font-weight:bold; background-color: #c8753f;">
          <td colspan="7" style="border:1px solid black; text-align:right; padding:6px;">
           Grand Total:
          </td>
          <td style="border:1px solid black; text-align:right; padding:6px;">
            {{ TotalBillAmt }}
          </td>
          <td style="border:1px solid black; text-align:right; padding:6px;">
            {{ TotalCreditNoteAmt }}
          </td>
        </tr>
      </tfoot>

    </table>
  </div>

  <!-- Buttons -->
  <div class="noPrint d-flex justify-content-end gap-3 px-4 mb-4 mt-3">
    <button class="btn btn-primary" (click)="exportExcel('BookCreditNote_InDetail_Report')">Export</button>
    <button class="btn btn-primary" (click)="printPage4()">Print</button>
    <button class="btn btn-secondary" mat-dialog-close>Close</button>
  </div>
</div>
